<template>
  <div class="parent-container">
    <div class="container">
      <top-slider/>
      <!--<div class="main-content">
        <h2>太原浩辰世纪科技发展有限公司</h2>
        <p style="text-align: left;text-indent: 4ch">
          成立于2006年，是一家拥有自主知识产权的高新技术企业、科技型中小企业，致力于信息化项目综合解决方案。</p>
      </div>-->
      <div class="child-content">
        <div class="left-content">
          <div style="display: flex;justify-content: space-between;background-color: #ACACFF;line-height: 2">
            <div style="font-weight: bolder;color: #000000;margin-left: 20px">浩辰PACS</div>
            <div style="margin-right: 20px;">
              <!--              <span style="color: #000000;text-decoration: underline;" @click="moreInfo">更多</span>-->
            </div>
          </div>
          <div class="pacs">
            <img :src="ct" width="100%">
          </div>
          <div class="into-more" @click="moreInfo">
            &nbsp;&nbsp;查&nbsp;&nbsp;&nbsp;&nbsp;看&nbsp;&nbsp;&nbsp;&nbsp;更&nbsp;&nbsp;&nbsp;&nbsp;多&nbsp;&nbsp;
          </div>
          <!--          <p>-->
          <!--            致力于数字化医院建设的高新技术企业，主要涉及医院数字化建设的信息技术研发、服务企业，为各大医疗机构提供医学影像工作站、医学影像网络系统及云影像系统。</p>-->
          <!--          <p>公司拥有自主知识产权的影像产品，服务医疗影像行业，为各大医疗机构提供高性价比的信息化解决方案。</p>-->
          <!--          <p>-->
          <!--            太原浩辰世纪科技发展有限公司作为国内众多影像设备与PACS系统厂商在山西的优质合作伙伴，我们为GE、Siemens、Philips、美迪康、琅伽、卫宁健康、健康山西等公司的山西客户提供了及时、高效的第三方服务，得到了各方广泛的认可。</p>-->
          <!--          <p>-->
          <!--            我们为山西医科大学第一医院、山西医科大学第二医院、山西省人民医院、山西白求恩医院、山西省肿瘤医院、山西省心血管病医院、山西省中医院、山西省中医药大学附属医院、山西省中西医结合医院、太原市中心医院、武警山西总队医院等百余家省内客户提供了专业的软件产品和服务。</p>-->
          <!--          <p>-->
          <!--            专心高效的服务保障了用户的投资，公司深知医疗信息系统的复杂与变化性，建立了完备的售前咨询体系与完善的客户服务中心，7*24小时的技术支持为用户系统正常运行提供保障，为客户提供有价值与有效率的服务是我们赢得客户信任的关键。</p>-->
        </div>
        <div class="right-content">
          <div style="display: flex;justify-content: space-between;background-color: #ACACFF;line-height: 2">
            <div style="font-weight: bolder;color: #000000;margin-left: 20px">公司简介</div>
            <div style="margin-right: 20px;">
              <!--              <span style="color: #000000;text-decoration: underline;">更多</span>-->
            </div>
          </div>
          <div style="height: 270px">
            <p>
              太原浩辰世纪科技发展有限公司成立于2006年，是一家拥有自主知识产权，致力于数字化医院建设的高新技术企业，主要涉及医院数字化建设的技术研发领域，为各大医疗机构提供医学影像工作站、医学影像网络系统及云影像系统。</p>
            <p>
              专心、高效的服务保障了用户的投资，公司深知医疗信息系统的复杂与变化性，建立了完备的售前咨询体系与完善的客户服务中心，7*24小时的技术支持为用户系统正常运行提供了保障，为客户提供有价值与有效率的服务是我们赢得客户信任的关键。
            </p>
            <p>国内众多影像设备与PACS系统厂商在山西的优质合作伙伴，得到了各方广泛的认可。</p>
          </div>
          <div class="into-more" @click="moreInfo">
            &nbsp;&nbsp;查&nbsp;&nbsp;&nbsp;&nbsp;看&nbsp;&nbsp;&nbsp;&nbsp;更&nbsp;&nbsp;&nbsp;&nbsp;多&nbsp;&nbsp;
          </div>
        </div>
      </div>
      <bottom-copyright/>
    </div>
  </div>
</template>
<script>
import ct from '@/assets/images/ct.jpg'
import BottomCopyright from "@/views/components/bottom-copyright.vue";
import TopSlider from "@/views/components/top-slider.vue";

export default {
  name: "MainView",
  components: {TopSlider, BottomCopyright},
  data() {
    return {
      ct,
    }
  },
  created() {

  },
  methods: {
    moreInfo() {
      this.$router.push({path: '/company-profile'})
    },
    moreInfoCostAnalysis() {
      this.$router.push({path: '/smart-cost-analysis'})
    }
  }
}
</script>
<style scoped>
.parent-container {
  background-color: #CCCCFF;
  width: 100%;
  display: flex;
}

.container {
  width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.child-content {
  display: flex;
  margin-top: 30px;
}

.left-content {
  margin-right: 50px;
}

.left-content, .right-content {
  flex: 1;
}

.into-more {
  line-height: 30px;
  background-color: #ACACFF;
  margin-top: 10px;
  cursor: pointer;
  font-weight: bolder;
  font-size: 14px;
}

.into-more:hover {
  text-decoration: underline;
}

.pacs {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  height: 277px;
}

.left-content p {
  text-indent: 4ch;
  text-align: left;
  line-height: 1.5;
}

.right-content p {
  text-indent: 4ch;
  text-align: left;
  line-height: 1.5;
}
</style>
